import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=05319dae&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05319dae",
  null
  
)

export default component.exports